(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-2023"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-sticky-button"] && !window.DesignMode) return;
  try {
    
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
      });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-focus-section-product"]) return;
  try {
    
jQuery(document).ready(function(){
    var swiper = new Swiper(".productfocus", {
      slidesPerView: "auto",
	  centeredSlides: false,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
